import { render, staticRenderFns } from "./ConstructionWorkerEdit.vue?vue&type=template&id=4e06d7a8"
import script from "./ConstructionWorkerEdit.vue?vue&type=script&lang=ts"
export * from "./ConstructionWorkerEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports